export default defineNuxtPlugin((nuxtApp) => {
//   const { currentGameSlug } = useGameComposable();
//   const gameStore = useGameStore();
//   gameStore.apiGetGame({ gameSlug: currentGameSlug  });
});
